export type OpportunityType =
  | 'Home'
  | 'Car'
  | 'SMSF'
  | 'Personal'
  | 'Insurance'
  | 'Refix'
  | 'Commercial';

export function displayOpportunityType(type: OpportunityType): string {
  return `${type}`;
}

export enum OpportunityWorkflowStatus {
  Draft = 'Pre-submission',
  ReadyToSubmit = 'Ready to Submit',
  Submitting = 'Submitting',
  // TODO: Should we consolidate 3 submitted statuses
  SubmittedToLiberty = 'Submitted to Liberty',
  SubmittedToLibertyCommercial = 'Submitted to Liberty Commercial',
  SubmittedToApplyOnline = 'Submitted to Apply Online',
  SubmittedToMoneyPlace = 'Submitted to MoneyPlace',
  SubmissionFailed = 'Submitted - Failed',
  Amending = 'Amending',
  ReadyToAssess = 'Ready to assess',
  Withdrawn = 'Withdrawn',
  Preapproved = 'Pre-approval',
  Approved = 'Approved',
  Unconditional = 'Unconditional',
  SettlementPending = 'Settlement pending',
  Settled = 'Settled',
  SettledConfirmed = 'Settled - Confirmed',
  Issued = 'Issued',
  SubmittedToPanelLender = 'Submitted - Spark+',
  Submitted = 'Submitted'
}

export type OpportunityWorkflowDisplayState = {
  status: OpportunityWorkflowStatus;
  provider?: string;
  libertyLoanId?: string;
  applyOnlineReference?: string;
  reasonForWithdraw?: string;
};

export enum DocumentStatus {
  Latest = 'Latest',
  Outdated = 'Outdated',
  Generating = 'Generating',
  GenerationFailed = 'GenerationFailed',
  NotGenerated = 'Not generated',
  Valid = 'Valid', // POS specific - document is valid and current
}

export enum RequiredDocumentType {
  AuthorityAndDeclaration = 'AuthorityAndDeclaration',
  ProductRecommendation = 'ProductRecommendation',
  EngagementScopeOfServices = 'EngagementScopeOfServices',
  DisclosureStatement = 'DisclosureStatement',
  ProvisionOfServices = 'ProvisionOfServices',
  NotRequired = 'NotRequired',
}

export type RequiredDocumentStatus = {
  documentName: string;
  status: DocumentStatus;
  type: RequiredDocumentType;
  outdatedMessages?: string[]; // Present when status is Outdated for POS - messages sent directly from backend
};
